import styled from "styled-components";
import { COLOR_VALUES } from "shared/config/colors";
import { TEXT_VARIANT_STYLES } from "./Text";

export const StyledText = styled.div((props) => {
    return {
        ...TEXT_VARIANT_STYLES[props.$variant],
        ...(props.$color ? { color: COLOR_VALUES[props.$color] } : {}),
        a: {
            cursor: "pointer",
            color: "inherit",
            textDecoration: "underline",
        },
        p: {
            marginBottom: "10px",
        },
        ul: {
            marginBottom: 0,
            marginBlockStart: 0,
            marginBlockEnd: "25px",
            marginInlineStart: 0,
            marginInlineEnd: 0,
            paddingInlineStart: "25px",
        },
    };
});
